<script>
import CustomCursor from "./components/CustomCursor.vue";
import Navbar from "./components/Navbar.vue";

export default {
  name: 'App',
  components: {
    CustomCursor,
    Navbar,
  },
};
</script>

<template>
  <div id="app" class="bg-brand-dark text-brand-cream min-h-screen flex flex-col">
    <Navbar />
    <div class="flex-1 min-h-screen bg-brand-dark">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </div>
    <CustomCursor />
  </div>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.35s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  .fade-enter-active, .fade-leave-active {
    transition: none;
  }
}
</style>
